import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "countdown"]
  static values = { cooldown: { type: Number, default: 15 }, active: { type: Boolean, default: false } }

  connect() {
    this._remaining = this.cooldownValue
    this._startCooldown()
  }

  disconnect() {
    if (this._timer) {
      clearInterval(this._timer)
      this._timer = null
    }
  }

  retry(event) {
    if (!this.activeValue) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  _startCooldown() {
    this.activeValue = false
    this._remaining = this.cooldownValue
    this._updateDisplay()
    this.element.disabled = true

    this._timer = setInterval(() => {
      this._remaining -= 1
      this._updateDisplay()

      if (this._remaining <= 0) {
        clearInterval(this._timer)
        this._timer = null
        this.activeValue = true
        this.element.disabled = false
        this._showReady()
      }
    }, 1000)
  }

  _updateDisplay() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = `Retry in ${this._remaining}s`
    } else {
      // Fall back to updating button text directly
      const textNode = this.element.childNodes[this.element.childNodes.length - 1]
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = ` Retry in ${this._remaining}s`
      }
    }
  }

  _showReady() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = "Retry"
    } else {
      const textNode = this.element.childNodes[this.element.childNodes.length - 1]
      if (textNode && textNode.nodeType === Node.TEXT_NODE) {
        textNode.textContent = " Retry"
      }
    }
  }
}
